import axios from 'axios'

export const axios_mock = axios.create({})
export const axios_live = axios.create({})